import { PublicSettings } from '@witkac/kartamiejska-shared';
import { RouteConfig } from 'vue-router';

import store from '@/store';
import { baseFilters } from '@/utils/baseFilters';
import { benefitFilters } from '@/utils/benefit';

export const eventsRoute: RouteConfig = {
  path: '/',
  component: () => import(/* webpackChunkName: "Events" */ '@/views/main/event/List.vue'),
  name: 'events',
  beforeEnter(to, _from, next) {
    const filters = {
      ...baseFilters(to, 12)
    };
    Promise.all([
      store.dispatch('benefit/list', benefitFilters(to, { count: 12 })),
      store.dispatch('settings/get', PublicSettings.CARD_STATE_COLOR),
      store.dispatch('settings/get', PublicSettings.NO_GROUP_SELECTED_NAME),
      store.dispatch('category/list', filters)
    ]).then(() => next());
  }
};
